import { render, staticRenderFns } from "./PercentageDiscountMechanic.vue?vue&type=template&id=6cd9dfd6&scoped=true"
import script from "./PercentageDiscountMechanic.vue?vue&type=script&lang=js"
export * from "./PercentageDiscountMechanic.vue?vue&type=script&lang=js"
import style0 from "./PercentageDiscountMechanic.vue?vue&type=style&index=0&id=6cd9dfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9dfd6",
  null
  
)

export default component.exports